import React, { useEffect, createElement } from 'react';
import { scheduleNonCritical } from './scheduling';
const META_PIXEL_ID = '27931902216435024';
type MetaPixelFunction = (action: 'init' | 'track', eventName: string) => void;
type QueuedMetaPixelFunction = MetaPixelFunction & {
  queue: Parameters<MetaPixelFunction>[];
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    scheduleNonCritical(initializeMetaPixel);
  }, []);
  return <noscript data-id="element-140" data-mp="2c02a8mlvu58z">
      <img alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} width="1" height="1" style={{
      display: 'none'
    }} data-id="element-141" data-mp="2c0kfu9ufpvtk" />
    </noscript>;
}
export function trackAddToCart() {
  initializeMetaPixel();
  window.fbq?.('track', 'AddToCart');
}
function initializeMetaPixel() {
  if (window.fbq) {
    return;
  }
  const pixel = ((...args: Parameters<MetaPixelFunction>) => {
    pixel.queue.push(args);
  }) as QueuedMetaPixelFunction;
  pixel.queue = [];
  window.fbq = pixel;
  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
}